import {
  fetchJsonData,
  postJsonData as postServiceJsonData,
} from './service.js'

const CACHE_KEY = 'SERVICE_CACHE'
let cache = {}

/**
 * Cache wrapper to fetchJsonData
 * @param url
 */
async function getJsonData(url) {
  let data = getDataByUrl(url)

  if (data) {
    return data
  } else {
    let fetchData = null

    await fetchJsonData(url).then((data) => {
      fetchData = data
      setDataByUrl(url, data)
    })

    return fetchData
  }
}

/**
 * Cache wrapper to postJsonData
 * @param url
 */
async function postJsonData(url, postData) {
  let data = getDataByUrl(url)

  if (data) {
    return data
  } else {
    let fetchData = null

    await postServiceJsonData(url, postData).then((data) => {
      fetchData = data
      setDataByUrl(url, data)
    })

    return fetchData
  }
}

/**
 * Clear the cache by url
 * @param url
 */
function clearCacheByUrl(url) {
  cache = JSON.parse(window.sessionStorage.getItem(CACHE_KEY))

  if (cache) {
    cache[url] = null
    window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache))
  }
}

/**
 * Wipe out the entire cache
 */
function clearAllCache() {
  cache = null
  window.sessionStorage.removeItem(CACHE_KEY)
}

/**
 * Returns data from the cache
 * @param url
 * @returns {*}
 */
const getDataByUrl = (url) => {
  cache = JSON.parse(window.sessionStorage.getItem(CACHE_KEY))

  if (cache) {
    return cache[url]
  } else {
    return null
  }
}

/**
 * Set data into the cache, with the url as the key
 * @param url
 * @param data
 */
const setDataByUrl = (url, data) => {
  if (!cache) {
    cache = {}
  }

  cache[url] = data
  updateCache()
}

const updateCache = () => {
  window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache))
}

export { getJsonData, postJsonData, clearAllCache, clearCacheByUrl }
